@if (resources$ | async; as resources) {
  @for (resource of resources; track resource) {
    <div class="flex flex-col">
      <form #a="ngForm" class="flex flex-row justify-between items-center h-10">
        <div class="w-full text-sm">{{ resource.name }}</div>
        <mat-checkbox [checked]="isResourceChecked(resource.id)"
          (change)="handleResourceClick.emit({state: $event.checked, resource: resource})"
        (click)="$event.stopPropagation()"></mat-checkbox>
      </form>
    </div>
  }
  <h5>Kategorien</h5>
  @for (category of filterCategories(resources); track category) {
    <div class="flex flex-col">
      <div class="flex flex-col " style="height: 38px;">
        <div class="flex flex-row justify-between items-center" (click)="handleCategoryClick.emit(category)">
          <div class="w-full" style="cursor: pointer">{{ category }}</div>
        </div>
      </div>
    </div>
  }
}